/* ==========================================================================
   Marmotech — product detail behaviour
   1. Gallery: thumbnail switches the main image
   2. Variant picker: option selects resolve to a variant; price/SKU/URL follow
   3. Spec tabs
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- gallery ---------- */
  (function gallery() {
    var root = document.querySelector('[data-mt-gallery]');
    if (!root) return;

    var images = root.querySelectorAll('[data-mt-gallery-image]');
    var thumbs = root.querySelectorAll('[data-mt-gallery-thumb]');
    if (!thumbs.length) return;

    function show(index) {
      for (var i = 0; i < images.length; i++) {
        var isActive = images[i].getAttribute('data-mt-gallery-image') === String(index);
        images[i].classList.toggle('is-active', isActive);
      }
      for (var j = 0; j < thumbs.length; j++) {
        var active = thumbs[j].getAttribute('data-mt-gallery-thumb') === String(index);
        thumbs[j].setAttribute('aria-current', active ? 'true' : 'false');
      }
    }

    for (var k = 0; k < thumbs.length; k++) {
      thumbs[k].addEventListener('click', function (event) {
        show(event.currentTarget.getAttribute('data-mt-gallery-thumb'));
      });
    }
  })();

  /* ---------- variants ---------- */
  (function variants() {
    var dataEl = document.querySelector('[data-mt-variants]');
    var form = document.getElementById('mt-product-form');
    if (!dataEl || !form) return;

    var list;
    try {
      list = JSON.parse(dataEl.textContent);
    } catch (error) {
      return; // Malformed payload — leave the server-rendered state alone.
    }
    if (!list || !list.length) return;

    var radios = form.querySelectorAll('.mt-variant__radio');
    if (!radios.length) return;

    var idField = form.querySelector('[data-mt-variant-id]');
    var priceEl = document.querySelector('[data-mt-price]');
    var skuEl = document.querySelector('[data-mt-sku]');
    var submit = form.querySelector('[data-mt-submit]');
    var submitText = form.querySelector('[data-mt-submit-text]');

    function money(cents) {
      // Shopify renders the server-side value with the shop's format; for
      // client updates we mirror the common two-decimal case.
      return (
        (cents / 100).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + ' ' + (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '')
      ).trim();
    }

    function chosen() {
      var values = [];
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        var idx = parseInt(radios[i].getAttribute('data-mt-option-index'), 10);
        values[idx] = radios[i].value;
      }
      return values;
    }

    function match(values) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    /**
     * Grey out values that cannot be bought alongside the current selection.
     * A value counts as available if some in-stock variant matches it while
     * agreeing with every OTHER chosen option.
     */
    function markAvailability() {
      var current = chosen();

      for (var i = 0; i < radios.length; i++) {
        var radio = radios[i];
        var idx = parseInt(radio.getAttribute('data-mt-option-index'), 10);
        var label = form.querySelector('label[for="' + radio.id + '"]');
        if (!label) continue;

        var reachable = false;
        for (var v = 0; v < list.length; v++) {
          var variant = list[v];
          if (variant.options[idx] !== radio.value) continue;
          if (!variant.available) continue;

          var agrees = true;
          for (var o = 0; o < current.length; o++) {
            if (o === idx) continue;
            if (current[o] && variant.options[o] !== current[o]) {
              agrees = false;
              break;
            }
          }
          if (agrees) {
            reachable = true;
            break;
          }
        }

        label.setAttribute('data-unavailable', reachable ? 'false' : 'true');
      }
    }

    function update() {
      var variant = match(chosen());
      markAvailability();

      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (skuEl) skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';

      if (submit) submit.disabled = !variant.available;
      if (submitText) {
        submitText.textContent = variant.available
          ? submit.getAttribute('data-label') || 'Add to Cart'
          : 'Sold out';
      }

      // Keep the URL shareable and the back button honest.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (submit && submitText) submit.setAttribute('data-label', submitText.textContent.trim());

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', update);
    }

    markAvailability();
  })();

  /* ---------- tabs ---------- */
  (function tabs() {
    var buttons = document.querySelectorAll('.mt-tabs__btn');
    if (!buttons.length) return;

    function select(button) {
      for (var i = 0; i < buttons.length; i++) {
        var isTarget = buttons[i] === button;
        buttons[i].setAttribute('aria-selected', isTarget ? 'true' : 'false');
        var panel = document.getElementById(buttons[i].getAttribute('aria-controls'));
        if (panel) panel.hidden = !isTarget;
      }
    }

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        select(event.currentTarget);
      });
    }
  })();
})();
